'use strict';

module.exports = strikethrough;

var all = require('../all');

function strikethrough(h, node) {
  return h(node, 'delete', all(h, node));
}
